import { createContext, useContext } from "react";
import type { AuthContextValue } from "../types/auth";

// The auth context lives here (with its hook) so contexts/AuthContext.tsx can
// stay a component-only file. Provided by <AuthProvider>.
export const AuthContext = createContext<AuthContextValue | null>(null);

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};
